<template>
  <div class="news-home-footer" v-if="!isLogin">
    <div>
      <p>立即注册，即刻开启您的<span>鸿联云</span>之旅</p>
      <a-button class="btn-red" size="large" @click="$router.push('/register')"
        >立即体验<a-icon type="right"
      /></a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: mapGetters(["isLogin"]),
};
</script>

<style lang="scss" scoped>
.news-home-footer {
  padding: 60px;
  background: url(../../assets/img/2.0/ydzcbg.png) no-repeat;
  background-size: 100% 100%;
  > div {
    width: 1280px;
    margin: 0 auto;
    > p {
      font-size: 32px;
      line-height: 44px;
      color: #000;
      margin-bottom: 32px;
      > span {
        color: #ea0b18;
      }
    }
    > button {
      display: block;
      width: 156px;
      height: 44px;
    }
  }
}
</style>
